<div class="{{currentAnimation}}">
    <ng-container *ngFor="let menu of menus">
        <nb-menu [tag]="menu.tag" class="selectable" [items]="menu.items" [ngClass]="{'display-none': tagActive != menu.tag}"></nb-menu>
    </ng-container>
</div>

